/**
 * @file supabase.ts
 * @description Standalone Supabase client configuration for TableGreet Digital TV Signage Engine.
 * 
 * INFRASTRUCTURE & CREDENTIAL STRATEGY:
 * 1. Exclusively routes through the TableGreet API gateway (https://api.tablegreet.com).
 * 2. Uses the worker-injected key sentinel ('WORKER_INJECTED') to protect credentials.
 * 3. Anonymous public client with session persistence disabled to prevent credential leakage.
 */

import { createClient } from '@supabase/supabase-js';

const SENTINEL = 'WORKER_INJECTED';
const LOCAL_DEV_API_PROXY_PATH = '/__tablegreet-api';

const isLocalDev = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' || 
   window.location.hostname.endsWith('.local'));

// In local dev, use the Vite forwarder to prevent CORS and browser security warnings
const resolvedUrl = isLocalDev 
  ? `${window.location.origin}${LOCAL_DEV_API_PROXY_PATH}`
  : (import.meta.env.VITE_API_URL || import.meta.env.VITE_SUPABASE_API_URL || 'https://api.tablegreet.com');

const resolvedAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || SENTINEL;

export const publicSupabase = createClient(resolvedUrl, resolvedAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
    storageKey: 'tablegreet_signage_anon',
  },
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'x-client-info': 'tablegreet-signage/1.0',
    },
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});
